import { render } from "./SShild.vue?vue&type=template&id=796ee170&ts=true"
import script from "./SShild.vue?vue&type=script&lang=ts"
export * from "./SShild.vue?vue&type=script&lang=ts"

import "./SShild.vue?vue&type=style&index=0&id=796ee170&lang=css"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__